export const maxWidth = 984;
export const maxTextWidth = 600;
